module.exports = __webpack_public_path__ + "static/play_button-ddceea91be911b49dd52edd9d19f17dc.png";